export default __webpack_public_path__ + "static/media/large.bbb2befb.jpg";